import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { DeleteIcon } from '../icons/DeleteIcon';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';
import { CancelButton } from "./CancelButton";
import { useTranslation } from 'react-i18next';


const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children?: React.ReactElement<any, any> },
    ref: React.Ref<unknown>,
  ) {
    return <Slide direction="up" ref={ref} {...props} />;
  });


// All the incoming values
interface IProps {
    disabled?: boolean;
    deleteWarningMessage?: string
    deleteWarningTitle?: string
}

// Outgoing functions
interface IDispatch {
    onClick: () => void
}

// Actual Component
export type AllProps = IProps & IDispatch;
export const DeleteButton = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t } = useTranslation('common');
    const [open, setOpen] = React.useState(false);

    const deleteWarningMessage = props.deleteWarningMessage || t('deleteWarningMessage');
    const deleteWarningTitle = "Verwijderen?";

    const handleClickOpen = () => {
        setOpen(true);
    }
    const handleClose = () => {
        setOpen(false);
    }
    const handleYes = () => {
        setOpen(false);
        props.onClick && props.onClick();
    }
    const handleNo = () => {
        setOpen(false);
    }


    return (<>
    <Button startIcon={<DeleteIcon />} disabled={props.disabled} onClick={e => {e.stopPropagation(); handleClickOpen();}} variant="contained" color="secondary">{t('delete')}</Button>
    <Dialog 
        open={open} 
        onClose={handleClose}
        TransitionComponent={Transition}
        keepMounted
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        >
        <DialogTitle id="alert-dialog-slide-title">{t('deleteWarningTitle')}</DialogTitle>
        <DialogContent dividers>
            <DialogContentText id="alert-dialog-slide-description">
                {deleteWarningMessage}
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button startIcon={<DeleteIcon />} disabled={props.disabled} onClick={handleYes} variant="contained" color="secondary">{t('delete')}</Button>
            <CancelButton onClick={handleNo} />
        </DialogActions>
    </Dialog>
    </>)
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({ }));